import KeenSlider from 'keen-slider';
import Plyr from 'plyr';

// lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

function setReferrer() {
  let referrer = document.referrer;
  let host = window.location.hostname;
  let href = window.location.href;

  // host is part of referrer
  if (referrer.includes(host)) {
    // referrer is not href
    if (referrer != href) {
      localStorage.setItem('referrer', referrer);
    }
  } else {
    localStorage.setItem('referrer', referrer);
  }
}
setReferrer();

document.addEventListener('DOMContentLoaded', function () {
  /**
   * SLIDER CE 008
   */
  if (document.querySelector('[data-slider]')) {
    function sliderNavigation(slider) {
      let wrapper, arrowLeft, arrowRight;

      function markup(remove) {
        wrapperMarkup(remove);
        arrowMarkup(remove);
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment);
      }
      function createDiv(className) {
        var div = document.createElement('div');
        var classNames = className.split(' ');
        classNames.forEach((name) => div.classList.add(name));
        return div;
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createDiv('arrow arrow--left');
        arrowLeft.addEventListener('click', () => slider.prev());
        arrowRight = createDiv('arrow arrow--right');
        arrowRight.addEventListener('click', () => slider.next());

        wrapper.prepend(arrowLeft);
        wrapper.prepend(arrowRight);
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode;
          while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper);

          removeElement(wrapper);
          return;
        }
        wrapper = createDiv('navigation-wrapper');
        slider.container.parentNode.appendChild(wrapper);
      }

      function enableDragAndLoop() {
        if (slider.options.loop == false || slider.options.drag == false) {
          let newOptions = slider.options;
          newOptions.drag = true;
          newOptions.loop = true;
          slider.update(newOptions);
        }
      }

      function disableDragAndLoop() {
        if (slider.options.loop == true || slider.options.drag == true) {
          let newOptions = slider.options;
          newOptions.drag = false;
          newOptions.loop = false;
          slider.update(newOptions);
        }
      }

      function updateClasses() {
        var slide = slider.track.details.rel;
        var navWrapper = slider.container.parentNode;
        slide === 0
          ? arrowLeft.classList.add('arrow--disabled')
          : arrowLeft.classList.remove('arrow--disabled');
        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add('arrow--disabled')
          : arrowRight.classList.remove('arrow--disabled');

        if (
          slider.slides.length <= slider.options.slides.perView &&
          typeof navWrapper != 'undefined'
        ) {
          navWrapper.classList.add('arrows--disabled');
          if (slider.slides.length == slider.options.slides.perView) {
            slider.container.classList.add('justify-content-start');
          } else {
            slider.container.classList.remove('justify-content-start');
          }
          disableDragAndLoop();
        } else if (
          arrowRight.classList.contains('arrow--disabled') &&
          arrowLeft.classList.contains('arrow--disabled') &&
          typeof navWrapper != 'undefined'
        ) {
          navWrapper.classList.add('arrows--disabled');
          slider.container.classList.remove('justify-content-start');
          disableDragAndLoop();
        } else {
          navWrapper.classList.remove('arrows--disabled');
          slider.container.classList.remove('justify-content-start');
          enableDragAndLoop();
        }
      }

      slider.on('created', () => {
        markup();
        updateClasses();
      });
      slider.on('optionsChanged', () => {
        markup(true);
        markup();
        updateClasses();
      });
      slider.on('slideChanged', () => {
        updateClasses();
      });
      slider.on('destroyed', () => {
        markup(true);
      });
    }

    function createNewSlider(node) {
      let slider = new KeenSlider(
        node,
        {
          slides: {
            origin: node.dataset.sliderOrigin ?? 'auto',
            perView: node.dataset.sliderSlides,
            spacing: 15,
          },
          loop: true,
          breakpoints: {
            '(min-width: 1024px)': {
              slides: {
                origin: node.dataset.sliderOrigin ?? 'auto',
                perView: node.dataset.sliderSlides,
                spacing: 15,
              },
            },
            '(max-width: 1024px)': {
              slides: {
                perView:
                  node.dataset.sliderSlides - 1 >= 1
                    ? node.dataset.sliderSlides - 1
                    : 1,
                spacing: 15,
              },
            },
            '(max-width: 768px)': {
              slides: {
                perView:
                  node.dataset.sliderSlides - 2 >= 1
                    ? node.dataset.sliderSlides - 2
                    : 1,
                spacing: 15,
              },
            },
          },
        },
        [
          sliderNavigation,
          (slider) => {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
              clearTimeout(timeout);
            }
            function nextTimeout() {
              clearTimeout(timeout);
              if (mouseOver) return;
              timeout = setTimeout(() => {
                slider.next();
              }, 5000);
            }

            // update slide classes
            function updateClasses() {
              let container = slider.container;
              let slideNumber = slider.track.details.rel;
              let activeSlide = slider.slides[slideNumber];

              // toggle slide classes
              slider.slides.forEach((slide) => {
                slide.classList.remove('keen-slider__slide--active');
              });
              activeSlide.classList.add('keen-slider__slide--active');

              // adaptive height
              if (container.hasAttribute('data-adaptive')) {
                container.style.height = 'auto';
              }
            }

            slider.on('created', () => {
              updateClasses();
              slider.container.addEventListener('mouseover', () => {
                mouseOver = true;
                clearNextTimeout();
              });
              slider.container.addEventListener('mouseout', () => {
                mouseOver = false;
                nextTimeout();
              });
              nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
            slider.on('slideChanged', () => {
              updateClasses();
            });
          },
          (slider) => {
            if (
              slider.container == document.querySelector('[data-slider="0"]')
            ) {
            }
          },
        ]
      );
    }

    document.querySelectorAll('[data-slider]').forEach((e) => {
      createNewSlider(e);
    });
  }

  /**
   * Content-Tabs CE 010
   */
  if (document.querySelector('[data-content-tabs]')) {
    function contentTabsNavigation(slider) {
      let wrapper, arrowLeft, arrowRight;

      function markup(remove) {
        wrapperMarkup(remove);
        arrowMarkup(remove);
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment);
      }
      function createDiv(className) {
        var div = document.createElement('div');
        var classNames = className.split(' ');
        classNames.forEach((name) => div.classList.add(name));
        return div;
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createDiv('arrow arrow--left');
        arrowLeft.addEventListener('click', () => slider.prev());
        arrowRight = createDiv('arrow arrow--right');
        arrowRight.addEventListener('click', () => slider.next());

        wrapper.appendChild(arrowLeft);
        wrapper.appendChild(arrowRight);
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode;
          while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper);
          removeElement(wrapper);
          return;
        }
        wrapper = createDiv('navigation-wrapper');
        slider.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(slider.container);
      }

      function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0
          ? arrowLeft.classList.add('arrow--disabled')
          : arrowLeft.classList.remove('arrow--disabled');
        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add('arrow--disabled')
          : arrowRight.classList.remove('arrow--disabled');
      }

      slider.on('created', () => {
        markup();
        updateClasses();
      });
      slider.on('optionsChanged', () => {
        markup(true);
        markup();
        updateClasses();
      });
      slider.on('slideChanged', () => {
        updateClasses();
      });
      slider.on('destroyed', () => {
        markup(true);
      });
    }

    function AdaptiveHeight(slider) {
      let firstHeightUpdate = 0;
      let padding = 64;
      let throttlePause;

      function throttle(callback, time) {
        if (throttlePause) return;

        throttlePause = true;
        setTimeout(() => {
          callback();
          throttlePause = false;
        }, time);
      }

      function getWidth() {
        return Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth
        );
      }

      function updateHeight() {
        if (getWidth() >= 768) {
          padding = 64;
        } else {
          padding = 24;
        }
        if (firstHeightUpdate == 0) {
          setTimeout(() => {
            slider.container.style.height =
              slider.slides[slider.track.details.rel].querySelector('.d-flex')
                .offsetHeight +
              2 * padding +
              'px';
          }, 500);
          firstHeightUpdate = 1;
        }
        slider.container.style.height =
          slider.slides[slider.track.details.rel].querySelector('.d-flex')
            .offsetHeight +
          2 * padding +
          'px';
      }

      slider.on('created', updateHeight);
      slider.on('slideChanged', updateHeight);
      window.addEventListener('resize', () => {
        throttle(updateHeight, 250);
      });
    }

    function ThumbnailPlugin(main) {
      return (slider) => {
        function removeActive() {
          slider.slides.forEach((slide) => {
            slide.querySelector('h3').classList.remove('active');
          });
        }
        function addActive(idx) {
          slider.slides[idx].querySelector('h3').classList.add('active');
        }

        function addClickEvents() {
          slider.slides.forEach((slide, idx) => {
            slide.addEventListener('click', () => {
              if (idx > slider.track.details.maxIdx) {
                slider.moveToIdx(slider.track.details.maxIdx);
              }
              slider.moveToIdx(idx);
              main.moveToIdx(idx);
            });
          });
        }

        slider.on('created', () => {
          addActive(slider.track.details.rel);
          addClickEvents();
          main.on('animationStarted', (main) => {
            removeActive();
            const next = main.animator.targetIdx || 0;
            addActive(main.track.absToRel(next));
            slider.moveToIdx(next);
          });
        });
      };
    }

    function createNewContentTabsSlider(e) {
      const mainSlider = new KeenSlider(e, {}, [
        contentTabsNavigation,
        //AdaptiveHeight,
      ]);
      const thumbnailElement = e
        .closest('.site-section--content-tabs')
        .querySelector('[data-content-tabs-thumbnails]');
      const thumbnails = new KeenSlider(
        thumbnailElement,
        {
          loop: false,
          slides: {
            perView: 'auto',
            spacing: 48,
          },
          range: {
            align: false,
          },
        },
        [ThumbnailPlugin(mainSlider)]
      );
    }

    document.querySelectorAll('[data-content-tabs]').forEach((e) => {
      createNewContentTabsSlider(e);
    });
  }

  /**
   * Video CE 015
   */

  if (document.querySelector('[data-video]')) {
    function createNewVideo(node) {
      const root = document.documentElement;
      const bigPlayButton = document.createElement('div');
      const plSpan = document.createElement('span');
      const aySpan = document.createElement('span');
      plSpan.innerHTML = 'PL';
      aySpan.innerHTML = 'AY';
      bigPlayButton.classList.add('plyr_play--big');

      let isPlayerClicked = 0;
      let preview = node.getAttribute('data-preview');

      // initiate Plyr player
      const player = new Plyr(node, {
        muted: true,
        hideControls: true,
        controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
        /* control options: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'] */
      });
      player.on('ready', () => {
        player.pause();
      });

      const playerDiv = node.closest('.plyr');

      // data preview attribute
      if (preview == 'true') {
        playerDiv.appendChild(bigPlayButton);
        bigPlayButton.appendChild(plSpan);
        bigPlayButton.appendChild(aySpan);

        // pause after 10 seconds of autoplay
        player.on('timeupdate', () => {
          if (isPlayerClicked == 0) {
            if (player.currentTime >= 9) {
              node.style.opacity = 0;
            }
            if (player.currentTime >= 10) {
              player.currentTime = 0;
              player.play();
              node.style.opacity = 1;
            }
          }
        });

        // restart video on first click and make options visible, also give player an additional class so the big play button won't reappear
        playerDiv.addEventListener('click', () => {
          isPlayerClicked += 1;
          if (isPlayerClicked == 1) {
            player.restart();
            player.volume = 1;
            player.play();
            playerDiv.classList.add('player-clicked');
          }
          let playerControls = node
            .closest('.plyr')
            .querySelector('.plyr__controls');
          playerControls.style.opacity = 1;
          playerControls.style.visibility = 'visible';
          node.closest('.plyr').style.cursor = 'auto';
        });

        // start autoplay if element is 100% in viewport
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (player.currentTime < 10 && isPlayerClicked == 0) {
                  player.volume = 0;
                  player.muted = true;
                  node.style.opacity = 1;
                  player.on('ready', () => {
                    player.play();
                  });
                }
              }
            });
          },
          { threshold: 1 }
        );
        observer.observe(playerDiv);

        // move big play button to mouse position
        playerDiv.addEventListener('mousemove', function (e) {
          var left =
            e.clientX -
            playerDiv.getBoundingClientRect().left -
            bigPlayButton.offsetWidth / 2 +
            'px';
          var top =
            e.clientY -
            playerDiv.getBoundingClientRect().top -
            bigPlayButton.offsetHeight / 2 +
            'px';
          bigPlayButton.style.left = left;
          bigPlayButton.style.top = top;
        });
      } else {
        playerDiv.classList.add('player-clicked');
        let playerControls = node
          .closest('.plyr')
          .querySelector('.plyr__controls');
        playerControls.style.opacity = 1;
        playerControls.style.visibility = 'visible';
        node.closest('.plyr').style.cursor = 'auto';
      }
    }

    document.querySelectorAll('[data-video]').forEach((e) => {
      createNewVideo(e);
    });
  }

  /**
   * Cookie Banner
   */
  if (document.querySelector('[data-toggle-cookie-tab]')) {
    document.querySelectorAll('[data-toggle-cookie-tab]').forEach((e) => {
      e.addEventListener('click', function () {
        document
          .getElementById('elc-cookie-consent')
          .classList.toggle('elc-hidden');
        document
          .getElementById('elc-cookie-tab')
          .classList.toggle('elc-hidden');

        document
          .getElementById('elc-cookie-consent')
          .classList.add('elc-fullwidth');
        document
          .getElementById('elc-cookie-consent')
          .classList.remove('elc-small');
      });
    });
  }
});
